import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  question: '📦 ¿Qué es el Combo Sin Gluten 3x1 y qué incluye?',
  answer: <div className="space-y-4" data-id="element-56">
        <p data-id="element-57">
          El Combo Sin Gluten 3x1 es una oferta exclusiva que incluye 3 ebooks
          digitales y 4 bonos adicionales para ayudarte a preparar en casa
          panes, bizcochos y postres deliciosos sin gluten, sin lactosa y sin
          azúcar refinada. El paquete completo incluye:
        </p>
        <ul className="list-disc pl-5 space-y-2" data-id="element-58">
          <li data-id="element-59">Ebook 1: Panadería Artesanal Sin Gluten</li>
          <li data-id="element-60">Ebook 2: Bizcochos Perfectos Sin Gluten</li>
          <li data-id="element-61">Ebook 3: Postres Irresistibles Sin Gluten</li>
          <li data-id="element-62">
            🎁 BONUS 1: Sistema Pan Siempre Fresco (Manual de Congelación y
            Conservación)
          </li>
          <li data-id="element-63">🎁 BONUS 2: Cenas Express en 15 Minutos</li>
          <li data-id="element-64">🎁 BONUS 3: El Arte de la Masa Madre Sin Gluten</li>
          <li data-id="element-65">
            🎁 BONUS 4: Manual de Rescate – Cómo Salvar una Masa en 60 Segundos
          </li>
        </ul>
        <p data-id="element-66">
          Con decenas de recetas probadas y detalladas, aprenderás a preparar
          panes, bizcochos y postres irresistibles desde tu propia cocina. ¡Son
          7 ebooks en total para transformar tu forma de cocinar sin gluten!
        </p>
      </div>
}, {
  question: '📥 ¿Puedo acceder a los ebooks de inmediato?',
  answer: '¡Sí! Después de completar tu compra, tendrás acceso inmediato a los ebooks. Podrás descargarlos al instante y comenzar a cocinar sin esperar.'
}, {
  question: '✅ ¿Son las recetas fáciles de seguir?',
  answer: '¡Claro! Los ebooks están diseñados para principiantes y cocineros caseros. Cada receta tiene instrucciones paso a paso y está acompañada de imágenes claras. No necesitas ser un experto para sorprender con estos deliciosos platos.'
}, {
  question: '❌ ¿Qué pasa si no me gustan los ebooks o no estoy satisfecho con la compra?',
  answer: 'No te preocupes, ofrecemos una garantía de devolución de 30 días. Si no estás completamente satisfecho por cualquier razón, solo tienes que enviarnos un correo y te devolveremos el 100% de tu dinero. ¡Así de simple!'
}, {
  question: '🥖 ¿Qué pasa si no tengo experiencia en cocina?',
  answer: '¡No te preocupes! Los ebooks están diseñados para principiantes. Cada receta está acompañada de instrucciones paso a paso y fotos, por lo que aprenderás a cocinar de manera fácil y divertida. ¡Te guiamos en todo el proceso!'
}, {
  question: '📲 ¿Puedo usar los ebooks en mi teléfono o tablet?',
  answer: '¡Sí! Los ebooks están diseñados para ser compatibles con todos los dispositivos. Puedes verlos en tu móvil, tablet o computadora, lo que te permitirá llevarlos contigo mientras cocinas o los consultes en cualquier lugar.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-16 px-4 bg-brand-cream" data-id="element-67">
      <div className="max-w-3xl mx-auto" data-id="element-68">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-69">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-brand-brown mb-4 flex items-center justify-center gap-3" data-id="element-70">
            <span className="text-4xl" data-id="element-71">🤔</span> Preguntas Frecuentes (FAQ)
          </h2>
          <div className="w-24 h-1 bg-brand-gold mx-auto rounded-full" data-id="element-72"></div>
        </motion.div>

        <div className="space-y-4" data-id="element-73">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-white rounded-xl shadow-sm border border-brand-cream overflow-hidden" data-id="element-74">
                <button onClick={() => toggleFAQ(index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" aria-expanded={isOpen} data-id="element-75">
                  <span className="font-bold text-brand-brown text-lg pr-8" data-id="element-76">
                    {faq.question}
                  </span>
                  <span className="flex-shrink-0 text-brand-gold" data-id="element-77">
                    {isOpen ? <Minus className="w-6 h-6 stroke-[3]" data-id="element-78" /> : <Plus className="w-6 h-6 stroke-[3]" data-id="element-79" />}
                  </span>
                </button>

                <AnimatePresence initial={false} data-id="element-80">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-81">
                      <div className="px-6 pb-6 pt-2" data-id="element-82">
                        <div className="w-full h-px bg-gray-100 mb-4" data-id="element-83"></div>
                        <div className="text-brand-brownLight leading-relaxed" data-id="element-84">
                          {faq.answer}
                        </div>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>

        <div className="text-center mt-10" data-id="element-85">
          <a href="#oferta" className="group relative inline-flex items-center justify-center gap-3 bg-brand-terracotta hover:bg-brand-terracottaHover text-white text-lg md:text-xl font-bold py-4 px-8 rounded-xl shadow-[0_8px_20px_rgba(196,93,44,0.3)] transition-all hover:-translate-y-1" data-id="element-86">
            DESCARGAR RECETAS ➤
          </a>
        </div>
      </div>
    </section>;
}